module.exports = __webpack_public_path__ + "img/check.f60644ea.svg";